'use client';
import Link from 'next/link';
import { NavigationMenuLink } from '../../ui/navigation-menu.jsx';
/**
 * Client component wrapper for sub-menu navigation links.
 *
 * Wraps `NavigationMenuLink asChild` with Next.js `Link` inside a client boundary
 * to prevent RSC lazy reference serialization from breaking Radix's `Slot` component.
 */
export var SubMenuLink = function (_a) {
    var className = _a.className, children = _a.children, href = _a.href;
    return (<NavigationMenuLink asChild>
    <Link className={className} href={href}>
      {children}
    </Link>
  </NavigationMenuLink>);
};
